import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    empresas: [],
    mantenimiento: null
  },
  actions: {    
    getMantenimiento ({ commit }, empresaId) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/empresas/${empresaId}`)
          .then((response) => {            
            commit('setMantenimientoMutation', response.data.mantenimiento)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getEmpresa (context, empresaId) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/empresas/${empresaId}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getEmpresas ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/empresas')
          .then((response) => {
            commit('setEmpresasMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addEmpresa ({ commit }, empresa) {
      return new Promise((resolve, reject) => {
        axios.post('/api/empresas', empresa)
          .then((response) => {
            commit('addEmpresaMutation', response)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteEmpresa ({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/empresas/${id}`)
          .then((response) => {
            commit('deleteEmpresaMutation', id)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateEmpresa ({ commit }, empresa) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/empresas/${empresa.id}`, empresa, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            commit('updateEmpresaMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    emptyEmpresas ({ commit }) {
      commit('emptyEmpresasMutation')
    }
  },
  mutations: {
    setMantenimientoMutation (state, e) {      
      state.mantenimiento = e
    },
    setEmpresasMutation (state, e) {
      state.empresas = e
    },
    addEmpresaMutation (state, e) {
      state.empresas.push(e)
    },
    updateEmpresaMutation (state, empresa) {
      const idx = state.empresas.findIndex((u) => u.id === empresa.id) // Buscamos o índice do elemento no array do state
      state.empresas.splice(idx, 1, empresa)
    },
    deleteEmpresaMutation (state, id) {
      const idx = state.empresas.findIndex((u) => u.id === id) // Buscamos o índice do elemento no array do state
      state.empresas.splice(idx, 1)
    },
    emptyEmpresasMutation (state) {
      // Vaciamos o store
      state.empresas = []
    }
  },
  modules: {}
})